import { useCallback, Dispatch, SetStateAction } from 'react';
import { useDrop } from 'react-dnd';
import update from 'immutability-helper';

const useDnD = <T>(
    dataLists: T[],
    setDataLists: Dispatch<SetStateAction<T[]>>,
    listId: string
) => {
    const findList = useCallback(
        (id: number) => {
            const list = dataLists.filter(
                (list: any) => list[listId] === id
            )[0];
            return {
                list,
                index: dataLists.indexOf(list)
            };
        },
        [dataLists, listId]
    );

    const moveList = useCallback(
        (id: number, atIndex: number) => {
            const { list, index } = findList(id);
            setDataLists(
                update(dataLists, {
                    $splice: [
                        [index, 1],
                        [atIndex, 0, list]
                    ]
                })
            );
        },
        [findList, dataLists, setDataLists]
    );

    const [, drop] = useDrop(() => ({ accept: 'list' }));

    return { dataLists, findList, moveList, drop };
};

export default useDnD;
